import React from 'react'
import styled from "styled-components";

import NftImg1 from '@/assets/imgs/nfts/1.jpg'
import NftImg2 from '@/assets/imgs/nfts/2.jpg'
import NftImg3 from '@/assets/imgs/nfts/3.jpg'
import NftImg4 from '@/assets/imgs/nfts/4.jpg'
import NftImg5 from '@/assets/imgs/nfts/5.jpg'
import NftImg6 from '@/assets/imgs/nfts/6.jpg'

export default function NftBanner() {

  return (
    <NftWrapper>
      <div className='wrapper-t'>
        <img className='index-img' src={NftImg5} alt="" />
        <img className='index-img' src={NftImg6} alt="" />
      </div>
      <div className='wrapper-b'>
        <img className='index-img' src={NftImg1} alt="" />
        <img className='index-img' src={NftImg2} alt="" />
        <img className='index-img' src={NftImg3} alt="" />
        <img className='index-img' src={NftImg4} alt="" />
      </div>
    </NftWrapper>
  )
}

const NftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 548px;
  .wrapper-t, .wrapper-b{
    display: flex;
    justify-content: space-between;
  }
  .wrapper-t{
    .index-img{
      display: block;
      width: 264px;
      border-radius: 20px;
    }
  }
  .wrapper-b{
    margin-top: 20px;
    .index-img{
      display: block;
      width: 124px;
      border-radius: 20px;      
    }
  }
`